import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useToastContext } from "@/common/components/ui/toast/toast.context";
import { ICompanyB2B } from "@/types/companyB2B.type";
import Loading from "@/common/components/ui/loading/Loading";
import { getCompanyB2BById } from "@/common/services/company-b2b.api";

export function EmpresaDetailsBlock() {
  // Assumindo que o ID está vindo do parâmetro de rota chamado 'id'
  const { id } = useParams<{ id: string }>();
  const { notifyError } = useToastContext();
  const [empresa, setEmpresa] = useState<ICompanyB2B | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!id) {
      notifyError("ID da empresa B2B não fornecido.");
      setIsLoading(false);
      return;
    }

    const fetchEmpresa = async () => {
      setIsLoading(true);
      const result = await getCompanyB2BById(id);

      if (result.ok && result.data) {
        setEmpresa(result.data);
      } else {
        notifyError(
          (result as { message?: string })?.message ||
          "Erro ao carregar detalhes da empresa B2B."
        );
      }
      setIsLoading(false);
    };

    fetchEmpresa();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  if (isLoading) {
    return <Loading />;
  }

  if (!empresa) {
    return (
      <div className="p-4 text-center text-gray-500">
        Empresa B2B não encontrada ou erro de carregamento.
      </div>
    );
  }

  return (
    <div className="p-4 space-y-4 bg-gray-50 rounded-lg shadow">
      <h3 className="text-xl font-bold border-b pb-2 text-gray-700">
        Informações Básicas da Empresa
      </h3>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        <div className="flex flex-col">
          <span className="text-sm font-medium text-gray-500">
            Razão Social
          </span>
          <span className="text-base text-gray-900 font-semibold">
            {empresa.socialReason}
          </span>
        </div>

        <div className="flex flex-col">
          <span className="text-sm font-medium text-gray-500">
            Nome Fantasia
          </span>
          <span className="text-base text-gray-900">{empresa.name}</span>
        </div>

        <div className="flex flex-col">
          <span className="text-sm font-medium text-gray-500">CNPJ</span>
          <span className="text-base text-gray-900">{empresa.cnpj}</span>
        </div>

        <div className="flex flex-col">
          <span className="text-sm font-medium text-gray-500">Contato</span>
          <span className="text-base text-gray-900">{empresa.phone}</span>
        </div>

        <div className="flex flex-col">
          <span className="text-sm font-medium text-gray-500">Status</span>
          <span
            className={`text-base font-medium ${empresa.active ? "text-green-600" : "text-red-600"
              }`}
          >
            {empresa.active ? "Ativo" : "Inativo"}
          </span>
        </div>

        <div className="flex flex-col">
          <span className="text-sm font-medium text-gray-500">Criado em</span>
          <span className="text-base text-gray-900">
            {new Date(empresa.createdAt).toLocaleDateString()}
          </span>
        </div>
      </div>
    </div>
  );
}
